import { Margin } from 'components/base/layout-components';
import { StyledGraphHeader } from './Header.style';
import Title from './Title';
import Text from 'components/base/Text';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';
import WidgetDescription from './WidgetDescription';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';
import { getDescriptionPerMetric } from './utils';

const Header = ({
  title,
  articleId,
  isEditable,
  isHover,
  subtitle = false,
  showNoDataInfoBox,
  graph,
  filters,
  isPmCustomDashboard,
  missingGraphData,
  dataCyPrefix,
  isEmptyStateMetric,
  loadingMetrics,
  formattedAverage,
  showTotal = true,
  shouldHideTitle = false,
  percentOffValue,
  isReportedMetric,
  ...rest
}) => {
  const { metricsCalculationStrategy } = useMetricsCalculationConfig();
  const formattedDescription = getDescriptionPerMetric({
    graph,
    filters,
    isPmCustomDashboard,
    percentOffValue,
    isReportedMetric,
    metricsCalculationStrategy
  });

  const descriptionProps = {
    showNoDataInfoBox,
    isEmptyStateMetric,
    dataCyPrefix,
    missingGraphData,
    isPmCustomDashboard,
    graph,
    filters,
    formattedAverage,
    formattedDescription,
    ...rest
  };

  return (
    <StyledGraphHeader direction='column' subtitle={Boolean(subtitle)}>
      {!shouldHideTitle && (
        <Title
          title={title}
          articleId={articleId}
          isEditable={isEditable}
          isHover={isHover}
          showTotal={showTotal}
          formattedDescription={formattedDescription}
          {...rest}
        />
      )}
      <Margin
        b={
          showNoDataInfoBox || loadingMetrics || (!subtitle && !showTotal)
            ? 'x-x-small'
            : 'normal'
        }
      >
        {subtitle && (
          <Text
            data-testid='customWidget-subtitle'
            color='shuttleGray'
            pb={SPACES.small}
            lineHeight={LINE_HEIGHT.small}
          >
            {subtitle}
          </Text>
        )}
        {!loadingMetrics && showTotal && formattedAverage && (
          <WidgetDescription
            {...descriptionProps}
            data-testid='customWidget-description'
          />
        )}
      </Margin>
    </StyledGraphHeader>
  );
};

export default Header;
